import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import {
  getEvaluationCategoryAnalysisResults,
  EvaluationCategoryAnalysisResultPayload
} from '../reducers/getEvaluationCategoryAnalysisResults';

const useGetEvaluationCategoryAnalysisResults = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  const getEvaluationCategoriesAnalysisResults = async (
    requestPayload: EvaluationCategoryAnalysisResultPayload[],
  ) => {
    try {
      setLoading(true);
      const resultAction = await dispatch(getEvaluationCategoryAnalysisResults(requestPayload));
      if (getEvaluationCategoryAnalysisResults.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setError(error);
    }
  };

  return { loading, error, getEvaluationCategoriesAnalysisResults };
};

export default useGetEvaluationCategoryAnalysisResults;
